<p-confirmDialog key="print" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid2Col">
	<label class="NoMargin">Start Date:</label>
	<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="StartDate" name="StartDate"></p-calendar>

	<label class="NoMargin">End Date:</label>
	<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="EndDate" name="EndDate"></p-calendar>

	<label class="NoMargin" style="align-self: baseline">Report Type:</label>

	<div class="MinorGrid2Col">
		<input id="Daily" value="Daily" name="ReportTypeOption" [(ngModel)]="ReportTypeOption" type="radio" />
		<label for="Daily" class="NoMargin">Daily</label>

		<input id="Summary" value="Summary" name="ReportTypeOption" [(ngModel)]="ReportTypeOption" type="radio" />
		<label for="Summary" class="NoMargin">Summary</label>

		<input id="Y2Y" value="Y2Y" name="ReportTypeOption" [(ngModel)]="ReportTypeOption" type="radio" />
		<label for="Y2Y" class="NoMargin">Year to Year</label>
	</div>

	<!--File Type-->
	<label>Output File Type</label>
	<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
			{{ o.Desc }}
		</option>
	</select>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="isProcessing == true" class="btn btn-primary" (click)="onPrintAttendance()">Print</button>
	<button [disabled]="isProcessing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>

<div class="TopMargin">
	<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
</div>
